<template>
  <v-app :class="[
    { 'app--logged': loggedIn && menuVisible },
    { 'app--menu': loggedIn && menuVisible && !hasMainMenuOpen },
    { 'route--without-menu': loggedIn && !menuVisible },
    `route--${routeName}`
  ]">
    <Navbar v-if="loggedIn" />

    <v-main>
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </v-main>

    <Snackbar />
    <CorpGlobalLoader />
    <CorpWatermark />
    <PreventCopyAndPasteText />
    <BrowserCompatibilityDialog />
    <ConnectionMonitoring />
    <WebChat />
  </v-app>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import mediaQueries from 'mixins/mediaQueries'
import Navbar from 'components/Navbar'
import Snackbar from 'components/Snackbar'
import CorpGlobalLoader from 'components/CorpGlobalLoader'
import CorpWatermark from 'components/CorpWatermark'
import PreventCopyAndPasteText from 'components/PreventCopyAndPasteText'
import BrowserCompatibilityDialog from 'components/BrowserCompatibilityDialog'
import ConnectionMonitoring from 'components/ConnectionMonitoring'
import WebChat from 'components/WebChat'

export default {
  name: 'App',
  mixins: [mediaQueries],
  components: {
    Navbar,
    Snackbar,
    CorpGlobalLoader,
    CorpWatermark,
    PreventCopyAndPasteText,
    BrowserCompatibilityDialog,
    ConnectionMonitoring,
    WebChat
  },
  metaInfo () {
    const titleTemplate = this.routeTitle
      ? `${this.routeTitle} | ${process.env.VUE_APP_TITLE}`
      : process.env.VUE_APP_TITLE

    return { titleTemplate }
  },
  computed: {
    ...mapState({
      loggedIn: ({ session }) => session.status.loggedIn,
      selectedlocale: ({ locale }) => locale.selected,
      hasMainMenuOpen: ({ mainMenu }) => mainMenu.isOpen
    }),

    isMobileDevice () {
      return this.isMobile || this.isTablet
    },

    routeName () {
      const routeName = this.$route.name || ''
      return routeName.toLowerCase()
    },

    routeTitle () {
      return this.$route.meta.title
    },

    menuVisible () {
      return this.$route.meta.menu
    }
  },
  methods: {
    ...mapActions({
      handleMainManuClose: 'mainMenu/toggle'
    }),

    setCurrentLocale () {
      this.$i18n.locale = this.selectedlocale
    },

    checkHostName () {
      const { hostname, port } = location

      if (process.env.NODE_ENV === 'development' && hostname !== 'developer') {
        location.href = `http://developer:${port}`
      }
    },

    async gmapsInit () {
      if (this.loggedIn) {
        await this.$gmaps.init()
      }
    }
  },
  watch: {
    '$route.name' (to, from) {
      const changeRoute = to && from && to !== from
      if (changeRoute && this.isMobileDevice) {
        this.handleMainManuClose()
      }
    },

    loggedIn (val) {
      this.gmapsInit()
    }
  },
  beforeMount () {
    this.setCurrentLocale()
    this.checkHostName()
  },
  created () {
    this.gmapsInit()
  }
}
</script>

<style lang="scss">
@import 'corp-front-vue-commons/src/assets/scss/index.scss';
@import '~@/assets/scss/index.scss';

.app--logged {
  padding: 169px 0 0;

  @media (min-width: 961px) {
    padding: ($toolbar-height * 2) 0 0 $menu-width;
  }
}

.app--menu {

  @media (min-width: 961px) {
    padding: ($toolbar-height * 2) 0 16px $mini-menu-width;
  }
}
</style>
